module.exports = __webpack_public_path__ + "static/media/Arrow_Right_Blue.28a95e12.svg";